export const LoanApplicationStatus = {
  NO_CONTACT: {
    value: 'no-contact',
    text: 'Sin contactar',
    permission: 'can_update_no_contact_status',
  },
  TRY_RECALL: {
    value: 'try-recall',
    text: 'Volver a llamar',
    permission: 'can_update_try_recall_status',
  },
  MISTAKEN: {
    value: 'mistaken',
    text: 'Equivocado',
    permission: 'can_update_mistaken_status',
  },
  DOES_NOT_HAVE: {
    value: 'does-not-have',
    text: 'No tiene',
    permission: 'can_update_does_not_have_status',
  },
  DOES_NOT_WANT: {
    value: 'does-not-want',
    text: 'No quiere',
    permission: 'can_update_does_not_want_status',
  },
  DOES_NOT_APPLY: {
    value: 'does-not-apply',
    text: 'No aplica',
    permission: 'can_update_does_not_apply_status',
  },
  UNABLE_TO_REACH: {
    value: 'unable-to-reach',
    text: 'No pude comunicarme',
    permission: 'can_update_unable_to_reach_status',
  },
  PENDING_RECEIVE_DOC: {
    value: 'pending-receive-doc',
    text: 'Pendiente recibir documentación',
    permission: 'can_update_pending_receive_doc_status',
  },
  RECEIVE_DOC: {
    value: 'receive-doc',
    text: 'Recibir documentación',
    permission: 'can_update_receive_doc_status',
  },
  PENDING_ANALYSIS: {
    value: 'pending-analysis',
    text: 'Pendiente de análisis',
    permission: 'can_update_pending_analysis_status',
  },
  CREDIT_ANALYSIS: {
    value: 'credit-analysis',
    text: 'Análisis de Crédito',
    permission: 'can_update_credit_analysis_status',
  },
  CREDIT_APPROVED: {
    value: 'credit-approved',
    text: 'Aprobado por Crédito',
    permission: 'can_update_credit_approved_status',
  },
  COMPLIANCE_REVIEW: {
    value: 'compliance-review',
    text: 'Revisión Cumplimiento',
    permission: 'can_update_compliance_review_status',
  },
  COMPLIANCE_APPROVED: {
    value: 'compliance-approved',
    text: 'Aprobado Cumplimiento',
    permission: 'can_update_compliance_approved_status',
  },
  FORMALIZATION_REVIEW: {
    value: 'formalization-review',
    text: 'Revisión Formalización',
    permission: 'can_update_formalization_review_status',
  },
  FORMALIZATION_APPROVED: {
    value: 'formalization-approved',
    text: 'Aprobado Formalización',
    permission: 'can_update_formalization_approved_status',
  },
  APPROVED: {
    value: 'approved',
    text: 'Crédito Aprobado',
    permission: 'can_update_approved_status',
  },
  LEGAL_AND_INSURANCE: {
    value: 'legal-and-insurance',
    text: 'Legal y Seguro',
    permission: 'can_update_legal_and_insurance_status',
  },
  PENDING_SIGNATURE: {
    value: 'pending-signature',
    text: 'Pendiente de firma',
    permission: 'can_update_pending_signature_status',
  },
  SIGNED: {
    value: 'signed',
    text: 'Firmado',
    permission: 'can_update_signed_status',
  },
  PENDING_TO_GENERATE_LOAN: {
    value: 'pending-to-generate-loan',
    text: 'Pendiente de generar préstamo',
    permission: 'can_update_pending_to_generate_loan_status',
  },
  GENERATED_LOAN: {
    value: 'generated-loan',
    text: 'Préstamo generado',
    permission: 'can_update_generated_loan_status',
  },
  DISBURSED: {
    value: 'disbursed',
    text: 'Desembolsado',
    permission: 'can_update_disbursed_status',
  },
  PAYOFF: {
    value: 'pay-off',
    text: 'Crédito saldado',
    permission: 'can_update_pay_off_status',
  },
  PENDING: {
    value: 'pending',
    text: 'Pendiente',
    permission: 'can_update_pending_status',
  },
  REJECTED: {
    value: 'rejected',
    text: 'Rechazado',
    permission: 'can_update_rejected_status',
  },
  CANCELED: {
    value: 'canceled',
    text: 'Cancelado',
    permission: 'can_update_canceled_status',
  },
};

const LoanApplicationStatusKeys = Object.keys(LoanApplicationStatus);

export const requestStatusOptions = LoanApplicationStatusKeys.map(
  p => LoanApplicationStatus[p]
);

export const LoanApplicationStatusTextFromValue = LoanApplicationStatusKeys.reduce(
  (prev, current) => {
    const loanApplicationStatus = LoanApplicationStatus[current];
    return {
      ...prev,
      [loanApplicationStatus.value]: loanApplicationStatus.text,
    };
  },
  {}
);

export const LoanApplicationStatusKeyFromValue = Object.keys(
  LoanApplicationStatus
).reduce(
  (prev, v, i) => ({
    ...prev,
    [Object.values(LoanApplicationStatus)[i].value]: v,
  }),
  {}
);

export const firstContactDefaultFormSituation = 'first-contact';
export const secondContactDefaultFormSituation = 'second-contact';

export default LoanApplicationStatus;



// WEBPACK FOOTER //
// ./src/utils/constants/RequestStatus.js